<script lang="ts">
  // @ts-nocheck
  import { primaryColor, widgetAccentColor, backgroundColorDark } from "$stores/community";
  import { getTextColorAndPrimaryVariants, convertHexToModernRgb } from "app/utils/colors";

  $: communityColors = getTextColorAndPrimaryVariants($primaryColor!);
  $: widgetAccentColors = getTextColorAndPrimaryVariants($widgetAccentColor!);
</script>

<svelte:head>
  {@html `<style>:root {
      --dark-custom-background: ${
        $backgroundColorDark ? convertHexToModernRgb($backgroundColorDark) : ""
      };
      --community-primary: ${convertHexToModernRgb($primaryColor)};
      --community-text-primary: ${convertHexToModernRgb(communityColors.textColor)};
      --community-primary-variant: ${convertHexToModernRgb(communityColors.primaryVariant)};
      --widget-accent: ${convertHexToModernRgb($widgetAccentColor)};
      --widget-text:  ${convertHexToModernRgb(widgetAccentColors.textColor)};
    }</style>`}
</svelte:head>
